module.exports = __webpack_public_path__ + "static/media/matching-score-coin-90.73d2924e.png";